import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { of, switchMap } from 'rxjs';
import { environment } from 'src/environment';
import { LoginService } from '../shared/services/login-service';
import { STORAGE_KEYS } from '../shared/storage-keys';
import { AuthStore } from '../store/auth-store';

export const generalGuad: CanActivateChildFn = (route, state) => {
  const loginService = inject(LoginService);
  const authStore = inject(AuthStore);
  const router = inject(Router);

  let token = localStorage.getItem(STORAGE_KEYS.userToken);
  let expiredToken = localStorage.getItem(STORAGE_KEYS.expiredTokenTime);
  if (!token || !expiredToken || expiredToken < new Date().getTime().toString()) {
    if (environment.auth == "jwt") {
      return router.parseUrl(authStore.navigateToLogin()!);
    }
    else {
      var guid = route.queryParams["connectionGuid"];
      return loginService.loginWithGuid(guid).pipe(
        switchMap(response => {
          if (response.token) {
            const experationDateTime = (new Date().getTime() + 1000 * 60 * authStore.ExpirationMinutes);
            localStorage.setItem(STORAGE_KEYS.userToken, response.token);
            localStorage.setItem(STORAGE_KEYS.expiredTokenTime, experationDateTime.toString());

            authStore.updateStoreVariable('token', response.token);
            authStore.updateStoreVariable('expireDate', experationDateTime);
          }
          if (response.token) {
            return of(true);
          }
          return of(router.parseUrl(authStore.navigateToLogin()!));
        }));
    }
  } else {
    return true;
  }
};
